export const SELECT_HEALTH_TOPPING_PLAN = 'SELECT_HEALTH_TOPPING_PLAN'

export const selectHealthToppingPlan = (planCode) => ({
  type: SELECT_HEALTH_TOPPING_PLAN,
  payload: planCode,
})
